<template>
  <el-drawer
    :append-to-body="false"
    :title="$t('product-manager::prop::table_prop')"
    :visible.sync="show"
    :wrapperClosable="false"
    @close="onChange"
    class="draw-attr-wrapper"
    custom-class="attr-drawer"
    direction="rtl"
    size="550px"
  >
    <el-row :gutter="15" style="padding: 0 24px;">
      <el-col :lg="24">
        <el-form :model="form" @submit.native.prevent ref="dynamicValidateForm">
          <el-table :data="form.items" :loading="loading">
            <el-table-column :label="$t('product-manager::prop_value::table_no')">
              <template slot-scope="{ $index }">
                <div class="prodinfo--table__imgTd">
                  <div>
                    <div>{{ $index + 1 }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              :label="$t('product-manager::prop_value::table_name')"
              prop="name"
              width="130"
            >
              <template slot-scope="{ row, $index }">
                <el-form-item
                  :key="$index"
                  :prop="`items.${$index}.name`"
                  :rules="[
                    {
                      required: true,
                      message: '',
                      trigger: 'change'
                    }
                  ]"
                  class="cell-name"
                  label
                  label-width="0"
                  v-if="row.isEdit == 'save'"
                >
                  <el-input
                    :min="0"
                    :placeholder="$t('product-manager::prop_value::placeholder_name')"
                    size="mini"
                    style="width: 100%"
                    v-model="row.name"
                  ></el-input>
                </el-form-item>
                <span v-else>{{ $dataCheck(row.name) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('product-manager::prop_value::table_creatTime')"
              prop="createTime"
              width="165"
            >
              <template slot-scope="{ row }">
                <div class="prodinfo--table__imgTd">
                  <div>
                    <div>{{ $dataCheck(row.createTime) }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('product-manager::prop::table_handle')" width="130">
              <template slot-scope="{ row, $index }">
                <el-button
                  :loading="row.loading"
                  @click="onBtnClick('save', $index, row)"
                  type="text"
                  v-if="row.isEdit === 'save'"
                >{{ $t('system::common::btn::save') }}</el-button>
                <template v-else>
                  <el-button
                    @click="onBtnClick('edit', $index, row)"
                    type="text"
                  >{{ $t('product-manager::prop::table_edit') }}</el-button>
                  <el-button
                    @click="onBtnClick('del', $index, row)"
                    type="text"
                  >{{ $t('product-manager::prop::table_delete') }}</el-button>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-col>
      <el-col :lg="24" class="mt-12" v-if="!isAdd">
        <el-button @click="onAdd">{{ $t('product-manager::prop_value::add_button') }}</el-button>
      </el-col>
    </el-row>
    <!-- <div class="draw-footer">
      <el-button size="medium" type="default" class="btn-item" @click="onChange">取消</el-button>
      <el-button size="medium" type="primary" class="btn-item" :loading="sendLoading" @click="onSend">发送</el-button>
    </div>-->
  </el-drawer>
</template>
<script>
import { updatePropValue, deletePropValue, propListValue } from '@/server/product.js'
import { getSession, setSession } from '@/utils/storage'
export default {
  name: 'write-attr-table-draw',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    drawRow: {
      default: () => {}
    }
  },
  watch: {
    visible (bool) {
      this.show = bool
      if (bool) {
        const data = this.drawRow
        this.getList(this.drawRow.item.id)
        this.$nextTick(() => this.$refs.dynamicValidateForm.clearValidate())
      }
    },
    drawRow: {
      handler: function (data) {},
      deep: true
    }
  },
  data () {
    return {
      selectSearch: {
        load: '',
        timer: null
      },
      isAdd: false,
      show: false,
      orderLoading: false,
      sendLoading: false,
      loading: false,
      form: {
        items: []
      }
    }
  },
  mounted () {},
  methods: {
    async getList (optionId) {
      this.loading = true
      const { data } = await propListValue({ optionId })
      if (data.code === this.$code) {
        this.form.items = (data.data || []).map(item => {
          return {
            name: item.value,
            ...item,
            loading: false,
            isEdit: 'edit'
          }
        })
      }
    },
    async onBtnClick (type, index, row) {
      console.log(row, 'row')
      if (type === 'edit') {
        if (this.isAdd) {
          this.$message.warning('请先保存')
          return
        }
        row.isEdit = 'save'
      } else if (type === 'save') {
        let err = 0
        this.$refs['dynamicValidateForm'].validateField([`items.${index}.name`], valid => {
          if (valid) {
            err += 1
          }
        })
        if (err === 0) {
          row.loading = true
          let res = null
          if (this.isAdd) {
            res = await updatePropValue({
              optionId: this.drawRow.item.id,
              value: row.name
            })
          } else {
            res = await updatePropValue({
              optionId: this.drawRow.item.id,
              value: row.name,
              id: row.id
            })
          }

          if (res.data.code === this.$code) {
            this.getList(this.drawRow.item.id)
          }
          row.loading = false
          this.isAdd = false
        }
      } else if (type === 'del') {
        this.loading = true
        const res = await deletePropValue({ id: row.id })
        if (res.data.code === this.$code) {
          this.getList(this.drawRow.item.id)
        }
      }
    },
    onChange () {
      this.$emit('change', false)
    },
    onAdd () {
      this.isAdd = true
      this.form.items.push({
        name: '',
        createTime: '',
        loading: false,
        isEdit: 'save'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-drawer__wrapper {
  ::v-deep {
    .el-form-item {
      .el-form-item__label {
        line-height: 40px;
      }
    }
    .el-tag__close {
      color: #fff;
      &:hover {
        background-color: inherit;
      }
    }
  }
}

::v-deep {
  .attr-drawer {
    // background: #f0f2f5;
    .el-drawer__header {
      font-size: 16px;
    }
    .el-drawer__header span:focus {
      outline: none;
    }
  }
}
.attr-drawer {
  .cell-name {
    margin-bottom: 0;
    ::v-deep {
      .el-form-item__error {
        display: none !important;
      }
    }
  }
  .send-input-item {
    width: 100%;
  }

  .item {
    line-height: 24px;
    word-break: keep-all;
    .info {
      color: $--color-text-primary;
    }
  }
  .order-wrapper {
    max-height: 100%;
    overflow: auto;
    .box-card {
      margin-bottom: 16px;
      border: 1px solid #ebeef5;
    }
  }
  .draw-footer {
    position: absolute;
    padding: 12px 0;
    left: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    background: #fff;
    .btn-item {
      margin-right: 10px;
    }
  }
  .empty-text {
    color: $--base-empty-color;
    text-align: center;
  }
}
</style>
